import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { from, of, switchMap } from 'rxjs';
import { StorageIntegrityService } from 'app/shared/security';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const storageIntegrity: StorageIntegrityService = inject(StorageIntegrityService);
    const authService: AuthService = inject(AuthService);

    return from(storageIntegrity.detectManipulation()).pipe(
        switchMap((manipulationDetected) => {
            if (manipulationDetected) {
                console.warn('[fabricaciones.scm.web] AuthGuard: Manipulation detected, redirecting to login');
                storageIntegrity.clearSecureData();
                const urlTree = router.parseUrl(`sign-in`);
                return of(urlTree);
            }

            return authService.check().pipe(
                switchMap((authenticated) => {
                    if (!authenticated) {
                        const urlTree = router.parseUrl(`sign-in`);
                        return of(urlTree);
                    }

                    return of(true);
                })
            );
        })
    );
};
